import { type FC } from 'react';

export const IntegrationsHeroGlobeIcon: FC = () => (
  <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M1.5 9H16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M9 1.5C10.876 3.55335 11.9422 6.22745 12 9C11.9422 11.7725 10.876 14.4467 9 16.5C7.12404 14.4467 6.0578 11.7725 6 9C6.0578 6.22745 7.12404 3.55335 9 1.5V1.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IntegrationsHeroShieldIcon: FC = () => (
  <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M8.25 15.5175C8.58152 15.3581 9.41848 15.3581 9.75 15.5175C10.8172 15.9822 14.25 13.0575 14.25 11.8125V4.5C14.25 4.08579 13.9142 3.75 13.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V11.8125C3.75 13.0575 7.18281 15.9822 8.25 15.5175Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IntegrationsHeroBoltIcon: FC = () => (
  <svg width={18} height={18} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M9.75 1.5L3.75 10.125H9L8.25 16.5L14.25 7.875H9L9.75 1.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
